import { gql } from "@apollo/client";

export const GET_ERRORES_BY_VISITA = gql`
  query erroresByVisita($idVisita: Int!) {
    erroresByVisita(idVisita: $idVisita)
  }
`;